import { Box, Button, Tooltip, styled, useTheme } from "@mui/material";
import { Credential } from "generated-graphql/graphql";
import { CredentialVerificationStatus } from "generated-graphql/graphql";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { relativeLogTime } from "util/dates";
import { useVerifyCredential } from "hooks/useVerifyCredentials";
import { FieldDisplay } from "./shared/FieldComponents";

const RELATIVE_TIME = 12;
const NEVER_CHECKED = "Never Checked";

export const CredentialVerification = ({
  credential,
  facilityId,
  disabled = false,
}: {
  credential: Credential | undefined | null;
  facilityId: string;
  disabled?: boolean;
}) => {
  const theme = useTheme();
  const [verifyCredential, { loading: sendingCredentialVerification }] =
    useVerifyCredential();
  const handleVerifyCredential = async () => {
    await verifyCredential({
      variables: {
        input: {
          facilityId: facilityId,
          credentialId: credential?.id,
        },
      },
      refetchQueries: ["GetTierIIReport", "GetCredential"],
    });
  };

  const verificationTime = credential?.lastVerificationCheckAt;
  const lastSuccessfulVerificationTime = credential?.lastVerificationSuccessAt;

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: theme.spacing(1) }}
    >
      <FieldDisplay
        label="Verification Status:"
        value={prettyPrintEnumValue(credential?.verificationStatus)}
        noWrap
      />
      <FieldDisplay
        label="Last Check:"
        value={
          <Tooltip title={verificationTime}>
            <span>
              {verificationTime
                ? relativeLogTime(verificationTime, RELATIVE_TIME)
                : NEVER_CHECKED}
            </span>
          </Tooltip>
        }
        noWrap
      />
      <FieldDisplay
        label={
          <>
            Last Successful
            <br />
            Verification Check:
          </>
        }
        value={
          <Tooltip title={lastSuccessfulVerificationTime}>
            <span>
              {lastSuccessfulVerificationTime
                ? relativeLogTime(lastSuccessfulVerificationTime, RELATIVE_TIME)
                : NEVER_CHECKED}
            </span>
          </Tooltip>
        }
        alignItems="flex-start"
        noWrap
      />
      <Box paddingTop={theme.spacing(1)}>
        <Button
          disabled={
            disabled ||
            credential?.verificationStatus ===
              CredentialVerificationStatus.CurrentlyVerifying ||
            !!sendingCredentialVerification
          }
          variant="outlined"
          onClick={handleVerifyCredential}
          size="small"
        >
          Verify Credential
        </Button>
      </Box>
    </Box>
  );
};
